import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ScrollableCards from './prograse/prograse';
import Why from './why/why';
import Work from './work/work'


const Home = () => {
  const [currentIndex1, setCurrentIndex1] = useState(0);
    const [courses, setCourses] = useState([]);
  

  const images1 = ["/Banner/banner-2.jpg", "/Banner/megascale-banner2.jpg", "/Banner/megascale-training-banner3.jpg"];
  const textArray = [
    { title: "Training By IT Professionals", subtitle: "You Can learn Anycourses" },
    { title: "Time Flexibility", subtitle: "You can learn Anycourses" },
    { title: "Live Project Experience", subtitle: "You can learn Anycourses" }
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex1((prevIndex) => (prevIndex + 1) % images1.length);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

   useEffect(() => {
      const fetchCourses = async () => {
        try {
          const response = await fetch(`https://training.megascale.co.in/backend/get_courses.php`);
          const data = await response.json();
          setCourses(data.courses);
        } catch (error) {
          console.error("Error fetching courses:", error);
        }
      };
      fetchCourses();
    }, []);

  const CourseCard = ({ title, image}) => {
    return (
      <div className="relative w-80 h-72 shadow-lg rounded-lg overflow-hidden bg-white">
        <img src={`https://training.megascale.co.in/backend/${image}`} alt={title} className="w-full h-60 object-cover" />
        <div className="absolute bottom-0 bg-blue-700 rounded-se-[50px]  text-white w-full p-4 ">
          <h3 className="text-lg font-semibold">{title}</h3>
          <div className="flex items-center justify-between ">
            {Array(5)
              .fill()
              .map((_, i) => (
                <span key={i} className={
                  i < Math.floor(4.5) ? "text-yellow-400" : "text-gray-400"
                }>
                  ★
                </span>
              ))}
            <Link
              to="/our-course"
              className="hover:text-blue-700 font-semibold transition-colors">
              <button className="bg-transparent border border-white px-3 py-1 rounded-md mt-2 hover:bg-white hover:text-blue-900 transition">
                Know More..!
              </button>
            </Link>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {/* Hero Section */}
      <div className="relative w-full h-full pt-20 bg-cover bg-center">
        {/* Background Image */}
        <img
          src={images1[currentIndex1]}
          alt="Slideshow"
          className="w-full h-full object-cover transition-opacity duration-1000 ease-in-out"
        />

        {/* ✅ Text Container Positioned at Bottom */}
        <div className="absolute bottom-10 left-0 w-full text-center px-4">
          <h2 className="text-black text-4xl md:text-5xl font-bold">
            {textArray[currentIndex1].title}
          </h2>
          <p className="text-black text-lg md:text-2xl mt-2">
            {textArray[currentIndex1].subtitle}
          </p>
        </div>
      </div>


      {/* Why Choose Us Section */}
      <main>
        <section className="bg-gray-100 py-12">
          <div className="container mx-auto px-1">
            <h2 className="text-3xl font-bold text-center mb-4">CHOOSE YOUR COURSE</h2>
            <h3 className="text-2xl md:text-3xl text-center font-extrabold text-blue-700 mb-4">
              GET THE WORLD CLASS & VERIFIED COURSE
            </h3>

            <div className="container mx-auto px-4 flex justify-center">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-9">
                {courses.map((course, index) => (
                  <div
                    key={index}
                    className={index === 9 ? "lg:col-span-3 flex justify-center" : ""}
                  >
                    <CourseCard {...course} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <ScrollableCards />
      <Why />
      <Work />


    </div>
  );
}

export default Home;
